export class GetBackupZeroEtlPolicyConnectionInfoResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalog",
            "baseName": "catalog",
            "type": "BackupZeroEtlGlueCatalogLocation",
            "format": ""
        },
        {
            "name": "storageLocations",
            "baseName": "storageLocations",
            "type": "Array<BackupZeroEtlLakeStorageLocation>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetBackupZeroEtlPolicyConnectionInfoResponse.attributeTypeMap;
    }
    constructor() {
    }
}
